/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Saving_Project_ToastInputs */

const en_shortcut_keys_saving_project_toast = /** @type {(inputs: Shortcut_Keys_Saving_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving project locally...`)
};

const fr_shortcut_keys_saving_project_toast = /** @type {(inputs: Shortcut_Keys_Saving_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement du projet en local...`)
};

const de_shortcut_keys_saving_project_toast = /** @type {(inputs: Shortcut_Keys_Saving_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt vor Ort sparen...`)
};

const it_shortcut_keys_saving_project_toast = /** @type {(inputs: Shortcut_Keys_Saving_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio del progetto in locale...`)
};

const ru_shortcut_keys_saving_project_toast = /** @type {(inputs: Shortcut_Keys_Saving_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранение проекта на местном уровне...`)
};

const es_shortcut_keys_saving_project_toast = /** @type {(inputs: Shortcut_Keys_Saving_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardando proyecto localmente...`)
};

const zh_cn2_shortcut_keys_saving_project_toast = /** @type {(inputs: Shortcut_Keys_Saving_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目保存到本地……`)
};

const ja_shortcut_keys_saving_project_toast = /** @type {(inputs: Shortcut_Keys_Saving_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトをローカルに保存しています...`)
};

const hi_shortcut_keys_saving_project_toast = /** @type {(inputs: Shortcut_Keys_Saving_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थानीय स्तर पर बचत परियोजना...`)
};

const pt_pt2_shortcut_keys_saving_project_toast = /** @type {(inputs: Shortcut_Keys_Saving_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvando projetos localmente...`)
};

/**
* | output |
* | --- |
* | "Saving project locally..." |
*
* @param {Shortcut_Keys_Saving_Project_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_saving_project_toast = /** @type {((inputs?: Shortcut_Keys_Saving_Project_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Saving_Project_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_saving_project_toast(inputs)
	if (locale === "de") return de_shortcut_keys_saving_project_toast(inputs)
	if (locale === "it") return it_shortcut_keys_saving_project_toast(inputs)
	if (locale === "ru") return ru_shortcut_keys_saving_project_toast(inputs)
	if (locale === "es") return es_shortcut_keys_saving_project_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_saving_project_toast(inputs)
	if (locale === "ja") return ja_shortcut_keys_saving_project_toast(inputs)
	if (locale === "hi") return hi_shortcut_keys_saving_project_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_saving_project_toast(inputs)
	return en_shortcut_keys_saving_project_toast(inputs)
});